import { Injectable } from '@angular/core';
import { jsPDF } from 'jspdf';
// import 'assets/js/jspdf_plugin.js';
import { Subject } from 'rxjs';
import { GlobalUtilService } from '@otas/core/services/global-util.service';

@Injectable()
export class UtilService {
    printerArrayBuffer: any;
    buttonDisableObservable = new Subject<boolean>();

    constructor(private globalUtilService: GlobalUtilService) {
        // this.customPDF();
    }

    customPDF() {

        // dpdf.addHTML(this.ptable.nativeElement, 20, 30)
        const doc = new jsPDF('l', 'in', [6, 4]);
        const rightStartCol1 = 280 / 72;
        const rightStartCol2 = 368 / 72;
        const InitialstartX = 40;
        const startX = 10 / 72;
        const InitialstartY = 50;
        let startY = 0;
        const lineHeights = 12;

        // Set font size and initial font (Times Bold)
        doc.setFontSize(12);
        doc.setFont('times', 'bold');

        // Send message to trigger image load
        this.globalUtilService.IPCRendererSend('getImg');

        this.globalUtilService.IPCRendererOn('imgstr', ((event, data) => {
            // Add the image to the PDF
            doc.addImage('data:image/jpeg;base64,' + data, 'PNG', startX, 20 / 72, 80 / 72, 50 / 72);

            // Add "Templename" text (using left alignment)
            doc.text('Templename', 200 / 72, 30 / 72, { align: 'left' });

            startY = (startY + 15 + 50);

            doc.setFontSize(12);
            // "GSTIN" in bold
            doc.setFont('times', 'bold');
            doc.text('GSTIN', startX, (startY += 12) / 72, { align: 'left' });
            // Switch to normal for following text
            doc.setFont('times', 'normal');
            doc.text('templeadd', 80 / 72, startY / 72, { align: 'left' });

            // "STATE" in bold then normal text "plce"
            doc.setFont('times', 'bold');
            doc.text('STATE', startX, (startY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('plce', 80 / 72, startY / 72, { align: 'left' });

            // "PAN" bold then "phone" normal
            doc.setFont('times', 'bold');
            doc.text('PAN', startX, (startY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('phone', 80 / 72, startY / 72, { align: 'left' });

            // "PIN" bold then normal
            doc.setFont('times', 'bold');
            doc.text('PIN', startX, (startY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('PIN', 80 / 72, startY / 72, { align: 'left' });

            // "EMAIL" bold then normal "companyEmail"
            doc.setFont('times', 'bold');
            doc.text('EMAIL', startX, (startY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('companyEmail', 80 / 72, startY / 72, { align: 'left' });

            // "Phone:" bold then normal "companyPhno"
            doc.setFont('times', 'bold');
            doc.text('Phone: ', startX, (startY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('companyPhno', 80 / 72, startY, { align: 'left' });

            let tempY = InitialstartY + 15;
            // "INVOICE NO:" bold then normal "InvoiceNo"
            doc.setFont('times', 'bold');
            doc.text('INVOICE NO: ', rightStartCol1, (tempY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('InvoiceNo', rightStartCol2, tempY / 72, { align: 'left' });

            // "INVOICE Date:" bold then normal "InvoiceDate"
            doc.setFont('times', 'bold');
            doc.text('INVOICE Date: ', rightStartCol1, (tempY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('InvoiceDate', rightStartCol2, tempY / 72, { align: 'left' });

            // "Reference No:" bold then normal "RefNo"
            doc.setFont('times', 'bold');
            doc.text('Reference No: ', rightStartCol1, (tempY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('RefNo', rightStartCol2, tempY / 72, { align: 'left' });

            // "Total:" bold then normal "TotalAmnt"
            doc.setFont('times', 'bold');
            doc.text('Total: ', rightStartCol1, (tempY += 12) / 72, { align: 'left' });
            doc.setFont('times', 'normal');
            doc.text('TotalAmnt', rightStartCol2, tempY / 72, { align: 'left' });

            // Output and save the PDF
            this.printerArrayBuffer = doc.output('blob');
            doc.save('save.pdf');
            this.globalUtilService.IPCRendererSend('readyToPrint', {});
        }).bind(this));
    }
}
